import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Avisa al resto de la app que la sesión terminó (el usuario cerró sesión
 * desde el sidenav / header / drawer, ver `AuthService.logout`).
 *
 * Vive aparte de `AuthService` por dos motivos:
 * - los tours de onboarding ya inyectan `AuthService` (leen el usuario del
 *   token para su flag de "ya lo vio"), así que `AuthService` no puede
 *   inyectarlos de vuelta sin un ciclo de dependencias;
 * - no tiene dependencias propias, así que los specs que mockean
 *   `AuthService` siguen resolviendo el real sin tocar nada.
 *
 * Lo escucha todo lo que sobrevive al logout en memoria — el logout es una
 * navegación de Angular, no un reload: los servicios `providedIn: 'root'`
 * (y cualquier timeout/suscripción que tengan viva) siguen ahí con el estado
 * de la sesión anterior.
 */
@Injectable({ providedIn: 'root' })
export class SessionEventsService {
  private readonly sessionEnded = new Subject<void>();
  readonly sessionEnded$: Observable<void> = this.sessionEnded.asObservable();

  notifySessionEnded(): void {
    this.sessionEnded.next();
  }
}
